export default "/images/vendor/@coreui/icons/svg/flag/cif-kw.svg?ef17c7df93e6239ce79625ba5e455999";